import { getAuthSession, type AuthSession } from '@/features/auth'
import { configureBootstrapLoader } from '@/entities/session'
import { setCsrfToken } from '@/shared/api/client'
import type { FrontendBootstrap, FrontendLinks } from '@/shared/types/api'

const links: FrontendLinks = {
  react_root: '/',
  dashboard: '/dashboard',
  statistics: '/statistics',
  legacy_dashboard: '/dashboard',
  browse: '/browse',
  study: '/study',
  note_types: '/note-types',
  installed_decks: '/installed-decks',
  flashcard_import: '/sync',
  shared_decks: '/marketplace/decks',
  shared_note_types: '/marketplace/note-types',
  orders: '/orders',
  support: '/support',
  terms: '/terms',
  privacy: '/privacy',
  cookies: '/cookies',
  admin_analytics: '/admin/analytics',
  admin_users: '/admin/users',
  admin_fees: '/admin/fees',
  admin_payments: '/admin/payments',
  admin_tts: '/admin/tts',
  admin_mcp_tokens: '/admin/mcp-tokens',
}

function toBootstrap(payload: AuthSession): FrontendBootstrap {
  const isAdmin = Boolean(payload.user?.is_admin)
  setCsrfToken(payload.csrf_token)
  return {
    api_version: 'v1',
    csrf_token: payload.csrf_token,
    user: payload.user,
    messages: [],
    support_contact_email: '',
    links: {
      ...links,
      admin_analytics: isAdmin ? links.admin_analytics : null,
      admin_users: isAdmin ? links.admin_users : null,
      admin_payments: isAdmin ? links.admin_payments : null,
      admin_tts: isAdmin ? links.admin_tts : null,
      admin_mcp_tokens: isAdmin ? links.admin_mcp_tokens : null,
    },
  }
}


export async function loadFrontendSession(): Promise<FrontendBootstrap> {
  return toBootstrap(await getAuthSession())
}

configureBootstrapLoader(loadFrontendSession)
